<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">
                            <b>Solicitações</b>
                        </h3>
                    </div>
                    <div class="box-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for>Unidade Solicitante</label>
                                    <select-unidade
                                        :show-text-danger-unidade="showTextDangerUnidadeSolicitante"
                                        @setUnidadeSelecionada="
                                            unidadeSelecionada => {
                                                setUnidadeSolicitante(unidadeSelecionada);
                                            }
                                        "
                                    ></select-unidade>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for>Profissional Solicitante</label>
                                    <select-profissional
                                        :show-text-danger-profissional="showTextDangerProfissionalSolicitante"
                                        @setProfissionalSelecionado="
                                            profissionalSelecionado => {
                                                setProfissionalSolicitante(profissionalSelecionado);
                                            }
                                        "
                                    ></select-profissional>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for>Unidade Prestadora</label>
                                    <select-unidade
                                        :show-text-danger-unidade="showTextDangerUnidadeSolicitante"
                                        @setUnidadeSelecionada="
                                            unidadeSelecionada => {
                                                setUnidadePrestadora(unidadeSelecionada);
                                            }
                                        "
                                    ></select-unidade>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for>Profissional Prestador</label>
                                    <select-profissional
                                        :show-text-danger-profissional="showTextDangerProfissionalSolicitante"
                                        @setProfissionalSelecionado="
                                            profissionalSelecionado => {
                                                setProfissionalPrestador(profissionalSelecionado);
                                            }
                                        "
                                    ></select-profissional>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for>Procedimento</label>
                                    <select-procedimento
                                        @setProcedimentoSelecionado="
                                            procedimentoSelecionado => {
                                                setProcedimentoSelecionado(procedimentoSelecionado);
                                            }
                                        "
                                    ></select-procedimento>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for>Paciente</label>
                                    <select-paciente
                                        @setPacienteSelecionado="
                                            paciente => {
                                                setPacienteSelecionado(paciente);
                                            }
                                        "
                                    ></select-paciente>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Grupo de Procedimento</label>
                                    <select name="grupo" class="form-control" v-model="grupoSelecionado" @change="setGrupoSelecionado()">
                                        <option value>Selecione o grupo...</option>
                                        <option v-for="(grupo, index) in grupos" :value="grupo" :key="index">{{ grupo.codigo }} - {{ grupo.nome }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for>Sub-Grupo</label>
                                    <select-subgrupo
                                        @setSubgrupoSelecionado="
                                            subgrupoSelecionado => {
                                                setSubgrupoSelecionado(subgrupoSelecionado);
                                            }
                                        "
                                    ></select-subgrupo>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-5">
                                <div class="form-group">
                                    <label for>Marcador</label>
                                    <select-usuario
                                        nivel="marcador"
                                        @setUsuarioSelecionado="
                                            usuario => {
                                                setUsuarioMarcadorSelecionado(usuario);
                                            }
                                        "
                                    ></select-usuario>
                                </div>
                            </div>

                            <div class="col-md-5">
                                <div class="form-group">
                                    <label for>Regulador</label>
                                    <select-usuario
                                        nivel="regulador"
                                        @setUsuarioSelecionado="
                                            usuario => {
                                                setUsuarioReguladorSelecionado(usuario);
                                            }
                                        "
                                    ></select-usuario>
                                </div>
                            </div>
                            <!--
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>Situação</label>
                                    <select name="st_solicitacao" v-model="filtros.situacao" id="st_solicitacao" class="form-control" style="width: 100%;">
                                        <option :value="null" selected="selected">Todos</option>
                                        <option :value="SITUACAO_SOLICITACAO.MARCADA">Marcada</option>
                                        <option :value="SITUACAO_SOLICITACAO.EM_REGULACAO">Em regulação</option>
                                        <option :value="SITUACAO_SOLICITACAO.REGULADA">Regulada</option>
                                        <option :value="SITUACAO_SOLICITACAO.NEGATIVADA">Negativada</option>
                                        <option :value="SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE">Informação pendente</option>
                                        <option :value="SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL">Informação adicional</option>
                                        <option :value="SITUACAO_SOLICITACAO.CONFIRMADA">Confirmada</option>
                                        <option :value="SITUACAO_SOLICITACAO.CANCELADA">Cancelada</option>
                                        <option :value="SITUACAO_SOLICITACAO.FALTA">Falta</option>
                                        <option :value="SITUACAO_SOLICITACAO.REALIZADA">Realizada</option>
                                    </select>
                                </div>
                            </div>
              -->
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>Tipo</label>
                                    <select name="tp_solicitacao" v-model="filtros.tipo_atendimento" id="tp_solicitacao" class="form-control" style="width: 100%;">
                                        <option :value="null" selected="selected">Todas</option>
                                        <option :value="TIPO_ATENDIMENTO.INDIVIDUAL">Individual</option>
                                        <option :value="TIPO_ATENDIMENTO.AGRUPADO">Agrupado</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Tipo de Unidade</label>
                                    <select v-model="filtros.tipo_unidade" class="form-control" style="width: 100%;">
                                        <option :value="null">Todos</option>
                                        <option :value="TIPO_UNIDADE.UNIDADE_BASICA">Unidade básica de saúde</option>
                                        <option :value="TIPO_UNIDADE.HOSPITAL">Hospital</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="dt_nascimento">Solicitado</label>
                                    <data-filtro name="solicitado" @operadorSelecionado="filtros.solicitadoOperador = $event" @dataSelecionada="filtros.solicitado = $event" @data2Selecionada="filtros.solicitado2 = $event"></data-filtro>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="dt_nascimento">Agendado</label>
                                    <data-filtro name="agendado" @operadorSelecionado="filtros.agendadoOperador = $event" @dataSelecionada="filtros.agendado = $event" @data2Selecionada="filtros.agendado2 = $event"></data-filtro>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="dt_nascimento">Regulado</label>
                                    <data-filtro name="regulado" @operadorSelecionado="filtros.reguladoOperador = $event" @dataSelecionada="filtros.regulado = $event" @data2Selecionada="filtros.regulado2 = $event"></data-filtro>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12">
                                <label class="checkbox-inline"> <input v-model="filtros.situacoes" type="checkbox" :value="SITUACAO_SOLICITACAO.MARCADA" />Marcada </label>
                                <div v-if="this.$store.state.user.nivel == 'administrador'">
                                    <label class="checkbox-inline"> <input v-model="filtros.situacoes" type="checkbox" :value="SITUACAO_SOLICITACAO.EM_REGULACAO" />Em regulação </label>
                                    <label class="checkbox-inline"> <input v-model="filtros.situacoes" type="checkbox" :value="SITUACAO_SOLICITACAO.REGULADA" />Regulada </label>
                                    <label class="checkbox-inline"> <input v-model="filtros.situacoes" type="checkbox" :value="SITUACAO_SOLICITACAO.NEGATIVADA" />Negativada </label>
                                    <label class="checkbox-inline"> <input v-model="filtros.situacoes" type="checkbox" :value="SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE" />Informação pendente </label>
                                    <label class="checkbox-inline"> <input v-model="filtros.situacoes" type="checkbox" :value="SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL" />Informação adicional </label>
                                </div>
                                <label class="checkbox-inline"> <input v-model="filtros.situacoes" type="checkbox" :value="SITUACAO_SOLICITACAO.CONFIRMADA" />Confirmada </label>
                                <label class="checkbox-inline"> <input v-model="filtros.situacoes" type="checkbox" :value="SITUACAO_SOLICITACAO.CANCELADA" />Cancelada </label>
                                <label class="checkbox-inline"> <input v-model="filtros.situacoes" type="checkbox" :value="SITUACAO_SOLICITACAO.FALTA" />Falta </label>
                                <label class="checkbox-inline"> <input v-model="filtros.situacoes" type="checkbox" :value="SITUACAO_SOLICITACAO.REALIZADA" />Realizada </label>
                            </div>
                        </div>

                        <div class="box-footer text-right" ref="filtrar">
                            <button class="btn btn-info" :disabled="finalizado" @click.self.prevent="getPDF()" v-if="pdf"><span class="fa fa-file-pdf-o" aria-hidden="true"></span> Recarregar PDF</button>
                            <button :disabled="finalizado" @click="getDataTable()" data-toggle="tooltip" title="Pesquisar Relatório de Solicitação" id="resultado" class="btn btn-primary"><i class="fa fa-search"></i> Pesquisar</button>
                        </div>
                        <br />
                        <div v-if="pdf">
                            <embed type="application/pdf" :src="pdf" width="100%" :height="heigthPdf" />
                        </div>
                        <div class="row" style="margin-top:15px" v-if="!isEmpty(dataTable) && !pdf && !filtros.sintetico">
                            <div class="col-md-12">
                                <div class="table-responsive form-group">
                                    <table role="grid" class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th v-show="ativos.situacao">Situação</th>
                                                <th v-show="ativos.tipo">Tipo</th>
                                                <th v-if="$store.state.user.nivel == 'administrador'" v-show="ativos.dt_solicitacao">Dt. Solicitação</th>
                                                <th v-show="ativos.dt_realizacao">Dt. Realização</th>
                                                <th v-show="ativos.cidadao">Paciente</th>
                                                <th v-show="ativos.endereco">Endereço</th>
                                                <th v-show="ativos.cidade">Cidade</th>
                                                <th v-show="ativos.bairro">Bairro</th>
                                                <th v-show="ativos.telefone">Telefone</th>
                                                <th v-show="ativos.rg">RG</th>
                                                <th v-show="ativos.nome_mae">Nome da Mãe</th>
                                                <th v-show="ativos.dt_nascimento">Dt. Nasc</th>
                                                <th v-show="ativos.idade">Idade</th>
                                                <th v-if="$store.state.user.nivel == 'administrador'" v-show="ativos.id">ID</th>
                                                <th v-show="ativos.quantidade">Qtd.</th>
                                                <th v-show="ativos.tipo_consulta">Consulta</th>
                                                <th v-show="ativos.procedimento">Procedimento</th>
                                                <th v-if="$store.state.user.nivel == 'administrador'" v-show="ativos.valor_prestador">Valor Prestador</th>
                                                <th v-if="$store.state.user.nivel == 'administrador'" v-show="ativos.valor">Valor Solicitante</th>
                                                <th v-if="$store.state.user.nivel == 'administrador'" v-show="ativos.valor_s">Valor de referência</th>
                                                <th v-show="ativos.unid_solic">Unid. Solicitante</th>
                                                <th v-show="ativos.unid_prest">Unid. Realizadora</th>
                                                <th v-show="ativos.prof_prest">Prof. Prestador</th>
                                                <th v-show="ativos.prof_solic">Prof. Solicitante</th>
                                                <th v-if="$store.state.user.nivel == 'administrador'" v-show="ativos.marcador">Marcador</th>
                                                <th v-if="$store.state.user.nivel == 'administrador'" v-show="ativos.regulador">Regulador</th>
                                                <th v-if="$store.state.user.nivel == 'administrador'" v-show="ativos.agp_unidades">Agrupamento de Unidades</th>
                                                <th v-if="$store.state.user.nivel == 'administrador'" v-show="ativos.usu_cancelamento">Usuário Cancelamento</th>
                                                <th v-show="ativos.dt_cancelamento">Dt. Cancelamento</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in dataTable.data" :key="index">
                                                <td v-show="ativos.situacao">{{ item.solicitacao.situacao | situacaoSolicitacao }}</td>
                                                <td v-show="ativos.tipo">{{ item.solicitacao.tipo_atendimento | tipoAtendimento }}</td>
                                                <td v-if="$store.state.user.nivel == 'administrador'" v-show="ativos.dt_solicitacao">{{ item.solicitacao.created_at | dataFormatadaHora }}</td>
                                                <td v-if="item.contrato_procedimento_atendimento || item.contrato_subgrupo_atendimento" v-show="ativos.dt_realizacao">{{ (item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento + " " + item.contrato_procedimento_atendimento.hora_inicial : item.contrato_subgrupo_atendimento.data_atendimento + " " + item.contrato_subgrupo_atendimento.hora_inicial) | dataFormatadaHora }}</td>
                                                <td v-else>SEM DATA DEFINIDA</td>
                                                <td v-show="ativos.cidadao">{{ item.solicitacao.paciente.nome }}</td>
                                                <td v-show="ativos.cidadao">{{ item.solicitacao.paciente.endereco }}, {{ item.solicitacao.paciente.numero_endereco }}</td>
                                                <td v-show="ativos.cidade">{{ item.solicitacao.paciente.cidade.nome }}</td>
                                                <td v-show="ativos.bairro">{{ item.solicitacao.paciente.bairro }}</td>
                                                 <td v-show="ativos.telefone">{{ item.solicitacao.paciente.telefone }}</td>
                                                <td v-show="ativos.rg">{{ item.solicitacao.paciente.rg }}</td>
                                                <td v-show="ativos.nome_mae">{{ item.solicitacao.paciente.nome_mae }}</td>
                                                <td v-show="ativos.dt_nascimento">{{ item.solicitacao.paciente.data_nascimento | dataFormatada }}</td>
                                                <td v-show="ativos.idade">{{ item.solicitacao.paciente.data_nascimento | idade }}</td>
                                                <td v-if="$store.state.user.nivel == 'administrador'" v-show="ativos.id">{{ item.solicitacao.id | formatarCodigo }}</td>
                                                <td  v-show="ativos.quantidade">{{ item.quantidade }}</td>
                                                <td  v-show="ativos.tipo_consulta">{{ item.tipo_consulta | tipoConsulta }}</td>
                                                <td  v-show="ativos.procedimento">{{ item.contrato_procedimento.procedimento.nome }}</td>
                                                    <div v-if="$store.state.user.nivel == 'administrador'">
                                                    <td v-if="item.contrato_procedimento_atendimento" v-show="ativos.valor_prestador">{{ item.contrato_procedimento_atendimento.contrato_procedimento.valor }}</td>
                                                    <td v-else>SEM VALOR DEFINIDO</td>
                                                    </div>
                                                    <td v-if="$store.state.user.nivel == 'administrador'" v-show="ativos.valor">{{ item.contrato_procedimento.valor }}</td>
                                                    <td v-if="$store.state.user.nivel == 'administrador'" v-show="ativos.valor_s">{{ item.contrato_procedimento.procedimento.valor_referencia }}</td>

                                                <td v-show="ativos.unid_solic">{{ item.contrato_procedimento.contrato.unidade.nome }}</td>
                                                <td v-if="item.contrato_procedimento_atendimento || item.contrato_subgrupo_atendimento" v-show="ativos.unid_prest">{{ item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.nome }}</td>
                                                <td v-else>SEM UNIDADE DEFINIDA</td>
                                                <td v-show="ativos.prof_prest">{{ item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.profissional.nome : "SEM PROFISSIONAL" }}</td>
                                                <td v-show="ativos.prof_solic">{{ item.solicitacao.profissional.nome }}</td>
                                                <td v-if="$store.state.user.nivel == 'administrador'" v-show="ativos.marcador">{{ item.solicitacao.usuario.name }}</td>
                                                <td v-if="$store.state.user.nivel == 'administrador'" v-show="ativos.regulador">{{ verificarRegulacao(item.solicitacao) }}</td>
                                                <td v-if="$store.state.user.nivel == 'administrador'" v-show="ativos.agp_unidades">{{ item.contrato_procedimento.contrato.unidade.tipo_unidade.nome }}</td>
                                                <td v-if="$store.state.user.nivel == 'administrador'" v-show="ativos.usu_cancelamento">{{ verificarCancelamento(item.solicitacao).text }}</td>
                                                <td v-show="ativos.dt_cancelamento">{{ verificarCancelamento(item.solicitacao).data }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="row" v-if="dataTable.data && dataTable.data.length > 0">
                                    <div class="col-sm-4">Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>
                                    <div class="col-sm-6" style="text-align:right">
                                        <laravue-pagination :limit="5" :data="dataTable" v-on:pagination-change-page="getDataTable">
                                            <span slot="prev-nav">&lt; Anterior</span>
                                            <span slot="next-nav">Próximo &gt;</span>
                                        </laravue-pagination>
                                    </div>
                                    <div class="col-sm-2 text-right">
                                        <button class="btn btn-info pdf" :disabled="finalizado" @click.self.prevent="getCSV"><span class="fa fa-download" aria-hidden="true"></span> CSV</button>
                                        <button class="btn btn-info pdf" :disabled="finalizado" @click.self.prevent="getPDF"><span class="fa fa-file" aria-hidden="true"></span> PDF</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div v-if="!isEmpty(dataTable)" class="row">
                            <div class="col-sm-3">
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.situacao" />Situação </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.tipo" />Tipo </label>
                                </div>
                                <div v-if="this.$store.state.user.nivel != 'prestador'" class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.dt_solicitacao" />Dt. Solicitação </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.dt_realizacao" />Dt. Realização </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.cidadao" />Cidadão </label>
                                </div>
                                 <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.cidade" />Cidade </label>
                                </div>
                                 <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.bairro" />Bairro </label>
                                </div>
                                  <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.telefone" />Telefone </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.rg" />RG </label>
                                </div>

                            </div>
                            <div class="col-sm-3">
                                 <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.nome_mae" />Nome da Mãe </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.dt_nascimento" />Dt. Nasc </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.idade" />Idade </label>
                                </div>
                                <div v-if="this.$store.state.user.nivel != 'prestador'" class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.id" />ID </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.quantidade" />Quantidade</label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.tipo_consulta" />Consulta</label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.procedimento" />Procedimento </label>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="checkbox" v-if="this.$store.state.user.nivel != 'prestador'">
                                    <label> <input type="checkbox" v-model="ativos.valor" />Valor </label>
                                </div>
                                 <div class="checkbox" v-if="this.$store.state.user.nivel != 'prestador'">
                                    <label> <input type="checkbox" v-model="ativos.valor_s" />Valor S </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.unid_solic" />Unid. Solicitante </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.unid_prest" />Unid. Realizadora </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.prof_prest" />Prof. Prestador </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.prof_solic" />Prof. Solicitante </label>
                                </div>
                                <div v-if="this.$store.state.user.nivel != 'prestador'" class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.marcador" />Marcador </label>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div v-if="this.$store.state.user.nivel != 'prestador'" class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.regulador" />Regulador </label>
                                </div>
                                 <div v-if="this.$store.state.user.nivel != 'prestador'" class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.agp_unidades" />Agrupamento de Unidades </label>
                                </div>

                                <div v-if="this.$store.state.user.nivel != 'prestador'" class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.usu_cancelamento" />Usuário Cancelamento </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.dt_cancelamento" />Data Cancelamento </label>
                                </div>
                                <br />
                                <!-- <input type="checkbox" v-model="ativos.tp_financiamento">Tipo de Financiamento<br/>
								<input type="checkbox" v-model="ativos.tp_agendamento">Tipo de Agendamento<br/>
                <input type="checkbox" v-model="ativos.auditoria">Auditoria<br/>-->
                            </div>
                        </div>
                        <!-- <div class="row" style="margin-top:15px">
									<div class="col-md-12">
										<div class="table-responsive form-group">
											<table role="grid" class="table table-bordered">
												<thead>
													<tr>
														<th v-for="(item, index) in filtros.agrupamentos" :key="index"> {{item.label}} </th>
														<th>Quantidade de procedimentos</th>
														<th>Quantidade de solicitações</th>
														<th>%</th>
														<th>Média</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(item, index) in dataTable.data" :key="index">
													</tr>
												</tbody>
											</table>
										</div>
										<div class="row" v-if="dataTable.data && dataTable.data.length > 0">
											<div class="col-sm-4">
												Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.
											</div>
											<div class="col-sm-6" style="text-align:right">
												<laravue-pagination :data="dataTable" v-on:pagination-change-page="getDataTable">
													<span slot="prev-nav">&lt; Anterior</span>
													<span slot="next-nav">Próximo &gt;</span>
												</laravue-pagination>
											</div>
											<div class="col-sm-2 text-right">
												<button class="btn btn-info pdf" :disabled="finalizado" @click.self.prevent="getPDF"><span class="fa fa-file-pdf-o" aria-hidden="true"></span> PDF</button>
											</div>
										</div>
									</div>
            </div>-->
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import selectUnidade from "@/components/cadastros/unidades/selectUnidade";
import selectProfissional from "@/components/cadastros/profissionais/selectProfissional";
import selectProcedimento from "@/components/cadastros/procedimentos/selectProcedimento";
import selectPaciente from "@/components/cadastros/pacientes/selectPaciente";
import selectSubgrupo from "@/components/cadastros/procedimentos/subgrupos/selectSubgrupo";
import selectUsuario from "@/components/cadastros/usuarios/selectUsuario";
import DataFiltro from "@/components/componentes/DataFiltro";
import { SITUACAO_SOLICITACAO, TIPO_ATENDIMENTO, TIPO_UNIDADE } from "@/constants";
import axios from "axios"; // Cliente para requisição http
// import Alert from '../../../Alert' // Importando componente alert

export default {
    components: {
        // Alert
        selectUnidade,
        selectProfissional,
        selectProcedimento,
        selectPaciente,
        selectSubgrupo,
        selectUsuario,
        DataFiltro
    },

    data: () => ({
        pdf: null,
        heigthPdf: 900,
        finalizado: false,
        showTextDangerUnidadeSolicitante: false,
        showTextDangerProfissionalSolicitante: false,
        grupos: [],
        grupoSelecionado: "",
        filtros: {
            sintetico: false,
            solicitado: null,
            solicitado2: null,
            solicitadoOperador: null,
            agendado: null,
            agendado2: null,
            agendadoOperador: null,
            regulado: null,
            regulado2: null,
            reguladoOperador: null,
            unidade_solicitante_id: null,
            unidade_solicitande: "",
            unidade_prestadora_id: null,
            unidade_prestadora: "",
            profissional_solicitante_id: null,
            profissional_solicitante: "",
            profissional_prestador_id: null,
            profissional_prestador: "",
            procedimento_id: null,
            procedimento: "",
            paciente_id: null,
            paciente: "",
            marcador_id: null,
            marcador: "",
            regulador_id: null,
            regulador: "",
            grupo_id: null,
            grupo: "",
            subgrupo_id: null,
            subgrupo: "",
            // situacao: null,
            tipo_atendimento: null,
            tipo_unidade: null,
            agrupamentos: null,
            ativos: null,
            situacoes: [SITUACAO_SOLICITACAO.MARCADA, SITUACAO_SOLICITACAO.EM_REGULACAO, SITUACAO_SOLICITACAO.REGULADA, SITUACAO_SOLICITACAO.NEGATIVADA, SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE, SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL, SITUACAO_SOLICITACAO.CONFIRMADA, SITUACAO_SOLICITACAO.CANCELADA, SITUACAO_SOLICITACAO.FALTA, SITUACAO_SOLICITACAO.REALIZADA]
        },
        selectAgrupamentos: [
            {
                label: "Unidade solicitante",
                value: "unidade_solicitante"
            },
            {
                label: "Unidade prestadora",
                value: "unidade_prestadora"
            },
            {
                label: "Profissional solicitante",
                value: "profissional_solicitante"
            },
            {
                label: "Profissional prestador",
                value: "profissional_prestador"
            },
            {
                label: "Procedimento",
                value: "procedimento"
            },
            {
                label: "Paciente",
                value: "paciente"
            },
            {
                label: "Nome do pai",
                value: "nome_pai"
            },
            {
                label: "Nome da mãe",
                value: "nome_ae"
            },
            {
                label: "Nome do pai",
                value: "nome_pai"
            },
            {
                label: "Nome do pai",
                value: "nome_pai"
            },
            {
                label: "RG",
                value: "rg"
            },
            {
                label: "Idade",
                value: "nome_pai"
            },
            {
                label: "Situação da solicitação",
                value: "situacao_solicitacao"
            },
            {
                label: "Tipo de solicitação",
                value: "tipo_solicitacao"
            },
            {
                label: "Data da solicitação",
                value: "data_solicitacao"
            },
            {
                label: "Data da realização",
                value: "data_realizacao"
            },
            {
                label: "Marcador",
                value: "marcador"
            },
            {
                label: "Regulador",
                value: "regulador"
            },
            {
                label: "Agrupamentos de Unidades",
                value: "agrupamento_unidades"
            },
            {
                label: "Grupo de Procedimento",
                value: "grupo"
            },
            {
                label: "Subgrupo de Procedimento",
                value: "subgrupo"
            },
            {
                label: "Município do Paciente",
                value: "municipio"
            },
            {
                label: "Bairro do Paciente",
                value: "bairro"
            },
            {
                label: "Horário da Solicitação",
                value: "horario_solicitacao"
            },
            {
                label: "Horário da Realização",
                value: "horario_realizacao"
            },
            {
                label: "Usuário Cancelamento",
                value: "usuario_cancelamento"
            },
            {
                label: "Tipo de Agendamento",
                value: "tipo_agendamento"
            },
            {
                label: "Data de Nascimento",
                value: "data_nascimento"
            },
            {
                label: "Data de Cancelamento",
                value: "data_cancelamento"
            }
        ],
        dataTable: {},
        ativos: {
            situacao: true,
            tipo: true,
            dt_solicitacao: true,
            dt_realizacao: true,
            cidadao: true,
            endereco: true,
            cidade: true,
            bairro: true,
            telefone: true,
            rg: true,
            nome_mae: true,
            dt_nascimento: true,
            idade: true,
            id: true,
            quantidade: true,
            tipo_consulta: true,
            procedimento: true,
            valor_prestador: true,
            valor: true,
            valor_s: true,
            unid_solic: true,
            unid_prest: true,
            prof_prest: true,
            prof_solic: true,
            marcador: true,
            regulador: true,
            agp_unidades: true,
            usu_cancelamento: true,
            dt_cancelamento: true
        }
    }),
    computed: {
        SITUACAO_SOLICITACAO: function() {
            return SITUACAO_SOLICITACAO;
        },
        TIPO_ATENDIMENTO: function() {
            return TIPO_ATENDIMENTO;
        },
        TIPO_UNIDADE: function() {
            return TIPO_UNIDADE;
        }
    },
    mounted() {
        if (this.$store.state.user.nivel == "prestador") {
            this.ativos.id = false;
            this.ativos.valor = false;
            this.ativos.valor_s = false;
            this.dt_solicitacao = false;
            this.marcador = false;
            this.regulador = false;
            this.agp_unidades = false;
            this.usu_cancelamento = false;
            this.filtros.situacoes = [SITUACAO_SOLICITACAO.MARCADA, SITUACAO_SOLICITACAO.CONFIRMADA, SITUACAO_SOLICITACAO.CANCELADA, SITUACAO_SOLICITACAO.FALTA, SITUACAO_SOLICITACAO.REALIZADA];
        }
        this.getGrupos();
    },

    methods: {
        getPDF(modelo) {
            this.finalizado = true;
            this.filtros.ativos = this.ativos;
            this.$store.commit("TOGGLE_LOADING");
            axios
                .post(`${this.$store.state.serverURI}/api/relatorios/solicitacaoImprimir`, this.filtros, this.$store.getters.getHeaderAuthFile)
                .then(response => {
                    this.$store.commit("TOGGLE_LOADING");
                    const file = new Blob([response.data], {
                        type: "application/pdf"
                    });
                    const fileURL = window.URL.createObjectURL(file);
                    this.pdf = fileURL;
                    let self = this;
                    this.heigthPdf = window.innerHeight - 65;
                    console.log(window.innerHeight);
                    setTimeout(function() {
                        self.$refs.filtrar.scrollIntoView();
                    }, 300);
                    this.finalizado = false;
                })
                .catch(error => {
                    this.$store.commit("throwException", error);
                    this.finalizado = false;
                });
        },
        getCSV() {
            this.$swal({
                title: `Fazer download das informações num arquivo CSV?`,
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(result => {
                if (result.value) {
                    this.finalizado = true;
                    this.filtros.ativos = this.ativos;
                    axios
                        .post(`${this.$store.state.serverURI}/api/relatorios/solicitacaoCSV`, this.filtros, this.$store.getters.getHeaderAuthFile)
                        .then(response => {
                            console.log(response.data);
                            const file = new Blob([response.data]);
                            const fileURL = window.URL.createObjectURL(file);
                            var fileLink = document.createElement("a");
                            fileLink.href = fileURL;
                            fileLink.setAttribute("download", "relatorio_solicitacoes" + new Date().toString() + ".csv");
                            document.body.appendChild(fileLink);
                            fileLink.click();

                            this.finalizado = false;
                        })
                        .catch(error => {
                            console.log(error);
                            this.finalizado = false;
                        });
                }
            });
        },
        isEmpty(objeto) {
            return Object.values(objeto).every(valor => valor === "");
        },
        verificarCancelamento(solicitacao) {
            let text = "Não foi cancelada";
            let data = "Não foi cancelada";
            solicitacao.solicitacao_historicos.forEach(element => {
                if (element.situacao == this.SITUACAO_SOLICITACAO.CANCELADA) {
                    text = element.usuario.name;
                    data = element.data
                        .split("-")
                        .reverse()
                        .join("/");
                }
            });

            let info = {
                text: text,
                data: data
            };

            return info;
        },
        verificarRegulacao(solicitacao) {
            let text = "Não foi regulada";
            solicitacao.solicitacao_historicos.forEach(element => {
                if (element.situacao == this.SITUACAO_SOLICITACAO.REGULADA) {
                    text = element.usuario.name;
                }
            });

			if (text == 'Não foi regulada') {
				solicitacao.solicitacao_historicos.forEach(element => {
					if (element.situacao == this.SITUACAO_SOLICITACAO.NEGATIVADA) {
						text = element.usuario.name;
					}
				});
			}

            return text;
        },
        getDataTable(page) {
            if (!this.filtros.solicitado) {
                this.$swal({
                    type: "warning",
                    title: "Atenção!",
                    text: "É necessário selecionar o período em que as solicitações foram feitas!",
                    showConfirmButton: true
                });
                return;
            }

            if (typeof page === "undefined") {
                page = 1;
            }

            this.finalizado = true;
            this.pdf = null;

            this.filtros.page = page;
            this.$store.commit("TOGGLE_LOADING");
            let config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;

            axios
                .get(`${this.$store.state.serverURI}/api/relatorios/solicitacao`, config)
                .then(response => {
                    this.dataTable = response.data;
                    this.finalizado = false;
                    this.$store.commit("TOGGLE_LOADING");
                })
                .catch(error => {
                    this.finalizado = false;
                    this.$store.commit("throwException", error);
                });
        },
        getGrupos() {
            axios
                .get(`${this.$store.state.serverURI}/api/cadastros/grupos-procedimento/getAll`, this.$store.getters.getHeaderAuth)
                .then(response => {
                    this.grupos = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        setUnidadeSolicitante(unidadeSolicitante) {
            this.filtros.unidade_solicitante_id = unidadeSolicitante.id;
            this.filtros.undidade_solicitante = unidadeSolicitante.nome;
        },
        setUnidadePrestadora(unidadePrestadora) {
            this.filtros.unidade_prestadora_id = unidadePrestadora.id;
            this.filtros.unidade_prestadora = unidadePrestadora.nome;
        },
        setProfissionalSolicitante(profissionalSolicitante) {
            this.filtros.profissional_solicitante_id = profissionalSolicitante.id;
            this.filtros.profissional_solicitante = profissionalSolicitante.nome;
        },
        setProfissionalPrestador(profissionalPrestador) {
            this.filtros.profissional_prestador_id = profissionalPrestador.id;
            this.filtros.profissional_prestador = profissionalPrestador.nome;
        },
        setProcedimentoSelecionado(procedimentoSelecionado) {
            this.filtros.procedimento_id = procedimentoSelecionado.id;
            this.filtros.procedimento = procedimentoSelecionado.nome;
        },
        setPacienteSelecionado(paciente) {
            this.filtros.paciente_id = paciente.id;
            this.filtros.paciente = paciente.nome;
        },
        setSubgrupoSelecionado(subgrupoSelecionado) {
            this.filtros.subgrupo_id = subgrupoSelecionado.id;
            this.filtros.subgrupo = subgrupoSelecionado.nome;
        },
        setUsuarioMarcadorSelecionado(usuario) {
            this.filtros.marcador_id = usuario.id;
            this.filtros.marcador = usuario.name;
        },
        setUsuarioReguladorSelecionado(usuario) {
            this.filtros.regulador_id = usuario.id;
            this.filtros.regulador = usuario.name;
        },
        setGrupoSelecionado() {
            this.filtros.grupo_id = this.grupoSelecionado.id;
            this.filtros.grupo = this.grupoSelecionado.nome;
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// index.vue?646cb366